import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWallEdit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("mask", {
			id: "we-badge-cut",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 0,
				y: 0,
				width: 24,
				height: 24,
				fill: "white"
			}), /* @__PURE__ */ _jsx("circle", {
				cx: 18.4,
				cy: 19.2,
				r: 7.6,
				fill: "black"
			})]
		}) }),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#we-badge-cut)",
			children: /* @__PURE__ */ _jsxs("g", {
				style: {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: "1.0px",
					strokeMiterlimit: 10
				},
				children: [
					/* @__PURE__ */ _jsx("path", { d: "M2,2h20v20h-20z" }),
					/* @__PURE__ */ _jsx("path", { d: "M2,7l20,0" }),
					/* @__PURE__ */ _jsx("path", { d: "M2,12l20,0" }),
					/* @__PURE__ */ _jsx("path", { d: "M2,17l20,0" }),
					/* @__PURE__ */ _jsx("path", { d: "M13,2l0,5" }),
					/* @__PURE__ */ _jsx("path", { d: "M7.5,7l0,5" }),
					/* @__PURE__ */ _jsx("path", { d: "M16.5,7l0,5" }),
					/* @__PURE__ */ _jsx("path", { d: "M11,12l0,5" }),
					/* @__PURE__ */ _jsx("path", { d: "M7.5,17l0,5" }),
					/* @__PURE__ */ _jsx("path", { d: "M16.5,17l0,5" })
				]
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "translate(11.4625 14.1375) scale(0.5)",
			style: {
				fill: "none",
				stroke: "currentColor",
				strokeWidth: "2.4px",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			},
			children: /* @__PURE__ */ _jsx("path", { d: "m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125" })
		})
	]
});
export default SvgWallEdit;
